import { Box, Tab, Tabs } from "@mui/material";
import { a11yProps, TabPanel } from "../../components/tab";
import { useState } from "react";
import { TabelaPrecoList } from "./tabelaPreco/tabpreco.view";
import { ConvenioList } from "./convenio/convenio.view";
import { ConvenioCadView } from "../config/config.view"

export function ViewRootSettings() {
    const [tabValue,setTabValue] = useState(0);
    const handleChangeTab = (event: React.SyntheticEvent, newValue: number)  => {
        setTabValue(newValue)
    }
    return (
        <Box sx={{ display:"flex",flex:1, flexDirection:"column",pt:1, width:"100%" }}>
          <Box sx={{display:"flex", flex:1, borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={tabValue} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile >
                    <Tab label="Tabela Preços" {...a11yProps(0)} />
                    <Tab label="Convênios" {...a11yProps(1)} />
                    <Tab label="Configuração" {...a11yProps(2)} />
                </Tabs>
           </Box>      
            <TabPanel value={tabValue} index={0} >
                <TabelaPrecoList />
            </TabPanel>
            <TabPanel value={tabValue} index={1} >
                <ConvenioList />
            </TabPanel>                 
            <TabPanel value={tabValue} index={2} >
                <ConvenioCadView />
            </TabPanel>                 

        </Box>        
    )
}